/**
    Higher order component of PageShell for global ad initialization of all ads on current page.  Responsible for "refreshing"
    all ads that are visible on initial page load
    The code for the global "admgr" is here https://code.espn.com/webdev/score/blob/develop/static/js/ads/admgr.js
    You can see the ad requests in the console by filtering on 'pubads'
*/
import React from 'react';
import { connect } from 'react-redux';
import hoistStatics from 'hoist-non-react-statics';
import { isElementInDOM } from 'lib/ui';
import { adsRefreshed, adsInitialized } from './actions';
import getMergedAdConfig from './util/getMergedAdConfig';

function connectAdInitializer(WrappedComponent) {
    class AdInitializer extends React.Component {
        constructor(props) {
            super(props);
            this.initAds = this.initAds.bind(this);
            this.refreshPageLoadAds = this.refreshPageLoadAds.bind(this);
            // hold on to a reference to the global admgr in case for some reason it is removed
            this.adManager = null;

            // array of gpt ads (these are tied to divs, but represented as objects with additoinal ad information)
            this.gptArray = [];
            this.adElementSelector = '.react-ad.ad-slot';
        }

        componentDidMount() {
            this.adManager = window.admgr || {};
            this.initAds();
        }

        componentWillReceiveProps(nextProps) {
            // refresh initially visible ads as early as possible.  also refresh for media queries
            if (this.props.mq !== nextProps.mq) {
                window.googletag.cmd.push(() => {
                    this.refreshPageLoadAds(nextProps);
                });
            }
        }

        // if this is a HOC of the PageShell, this is only called on route changes
        componentDidUpdate(prevProps) {
            if (prevProps.ads !== this.props.ads) {
                this.initAds();
            }
        }

        initAds() {
            const { ads = {}, dispatch } = this.props;
            if (ads.id && ads.configured && (!ads.initialized || ads.refresh === true)) {
                try {
                    if (isElementInDOM(this.adElementSelector)) {
                        const adConfig = getMergedAdConfig(this.props);
                        this.adManager.init(adConfig);
                        window.googletag.cmd.push(() => {
                            this.gptArray = this.adManager.getGPTArray({ independent: false });
                            dispatch(adsInitialized());
                            this.refreshPageLoadAds(this.props);
                        });
                    }
                } catch (err) {
                    console.error(err); // eslint-disable-line
                }
            }
        }

        refreshPageLoadAds(props = {}) {
            const { dispatch } = props;
            // obtain the elements of all ads that will be refreshed on pageload, then map them to their GPT items
            const pageLoadAds = document.querySelectorAll('.react-ad.ad-slot[data-refresh-on-pageload=true]');
            const pageLoadGptArray = this.gptArray
                .filter((gptElement) => {
                    let refreshOnLoad = false;
                    Array.prototype.forEach.call(pageLoadAds, (pageLoadAd) => {
                        if (pageLoadAd.id === gptElement.getSlotElementId()) {
                            refreshOnLoad = true;
                        }
                    });
                    return refreshOnLoad;
                });
            if (pageLoadGptArray.length > 0) {
                this.adManager.refresh(pageLoadGptArray);
                dispatch(adsRefreshed());
            }
        }
        render() {
            return <WrappedComponent {...this.props} {...this.state} />;
        }
    }

    AdInitializer.propTypes = {
        ads: React.PropTypes.object,
        dispatch: React.PropTypes.func,
        mq: React.PropTypes.string
    };

    const mapStateToProps = (state) => ({
        ads: state.ads,
        mq: state.app.mq
    });

    return connect(mapStateToProps)(hoistStatics(AdInitializer, WrappedComponent));
}

export default connectAdInitializer;



// WEBPACK FOOTER //
// ./app/ads/connectAdInitializer.js